export interface AuthUserPayload {
    name?: string;
    email?: string;
    is_admin?: boolean;
}

export function extractAuthSession(response: unknown): { token: string | null; user: AuthUserPayload | null } {
    if (!response || typeof response !== "object") {
        return { token: null, user: null };
    }

    const root = response as Record<string, unknown>;
    const nestedData = root.data && typeof root.data === "object" ? (root.data as Record<string, unknown>) : root;

    const directToken = nestedData.token || nestedData.access_token || nestedData.jwt;
    const token = typeof directToken === "string" && directToken.trim() ? directToken : null;

    const nestedUser = nestedData.user;
    if (nestedUser && typeof nestedUser === "object") {
        const userRecord = nestedUser as Record<string, unknown>;
        return {
            token,
            user: {
                name: typeof userRecord.name === "string" ? userRecord.name : undefined,
                email: typeof userRecord.email === "string" ? userRecord.email : undefined,
                is_admin: userRecord.is_admin === true,
            },
        };
    }

    return { token, user: null };
}
